<template>
  <div class="forwardingReport" ref="body" @click="expirationOpen = false">
    <div class="hierarchy">
      <!-- <div class="dataTitle">
        <van-icon class="hospiyalsArrowLeft" style="top: 16px;" name="arrow-left" @click="onBack" />
        <div class="title">
          <div class="content" @click="toReport" v-if="examReport">检查报告</div>
          <div class="line" v-if="examReport">|</div>
          <div class="content" @click="toPortrait">数字影像</div>
          <div class="line">|</div>
          <div class="content action">转发报告</div>
        </div>
      </div>-->
      <div v-if="report">
        <div class="settingCard expirationCard">
          <div class="settingHead">
            <div>
              <div class="settingTitle">有效期</div>
              <div class="settingDescription">报告链接将在 {{value}} 天后失效</div>
            </div>
            <div class="expirationSelect">
              <button
                type="button"
                class="expirationTrigger"
                :aria-expanded="expirationOpen"
                @click.stop="expirationOpen = !expirationOpen"
              >
                <span>{{value}}天</span>
                <van-icon name="arrow-down" :class="{open: expirationOpen}" />
              </button>
              <div v-if="expirationOpen" class="expirationOptions" role="listbox">
                <button
                  v-for="item in option1"
                  :key="item.value"
                  type="button"
                  class="expirationOption"
                  :class="{selected: item.value === value}"
                  @click.stop="selectExpiration(item.value)"
                >
                  <span>{{item.text}}</span>
                  <van-icon v-if="item.value === value" name="success" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="settingCard">
          <div class="settingHead">
            <div class="settingCopy">
              <div class="settingTitle">数据脱敏</div>
              <div class="settingDescription">隐藏报告中的敏感信息（姓名、医院名称）</div>
            </div>
            <div class="switchBox">
              <label class="switchControl">
                <input type="checkbox" :checked="isAnonymous === 1" @change="toggleOption('anonymous', $event.target.checked)" />
                <span class="switchTrack"><span class="switchThumb"></span></span>
              </label>
              <span class="switchStatus">{{isAnonymous === 1 ? '已开启' : '已关闭'}}</span>
            </div>
          </div>
          <div class="settingHint">
            <!-- 如姓名：{{maskedName}}（已隐藏），医院{{maskedHospital}}（已隐藏） -->
            如姓名: ***（已隐藏），医院 ******（已隐藏）
          </div>
        </div>
        <div class="settingCard encryptionCard">
          <div class="settingHead">
            <div class="settingCopy">
              <div class="settingTitle">访问加密</div>
              <div class="settingDescription">访问者必须输入密码才能查看报告</div>
            </div>
            <div class="switchBox">
              <label class="switchControl">
                <input type="checkbox" :checked="isEncrypt === 1" @change="toggleOption('encrypt', $event.target.checked)" />
                <span class="switchTrack"><span class="switchThumb"></span></span>
              </label>
              <span class="switchStatus">{{isEncrypt === 1 ? '已开启' : '已关闭'}}</span>
            </div>
          </div>
          <div class="settingHint passwordHint" v-if="isEncrypt === 1">
            <van-icon name="lock" />
            <span>设置访问密码：{{linkReady ? (forwardingData.code || '----') : '----'}}</span>
          </div>
          <div class="settingFootnote" v-if="isEncrypt === 1">* 请在转发时告知访问密码</div>
        </div>
        <div class="forwardingActionBar">
          <div v-if="linkError" class="linkError">链接生成失败，请重新生成</div>
          <van-button
            v-if="linkError"
            type="primary"
            class="copyButton"
            :loading="linkLoading"
            :disabled="linkLoading"
            @click="retryMakeReportLink"
          >
            重新生成链接
            <van-icon name="refresh" />
          </van-button>
          <van-button
            v-else
            type="primary"
            class="copyButton"
            :loading="linkLoading"
            :disabled="linkLoading || !linkReady"
            @click="toCopy"
          >
            复制安全链接转发报告
            <van-icon name="share-o" />
          </van-button>
        </div>
      </div>
      <div v-if="noreport" class="white_title">暂无报告</div>
    </div>
    <div class="montmorillonite" @click="Montmorillonite" v-if="montmorillonite">
      <img class="arrowDirection" src="../../../../assets/guide.png" alt />
      <div class="forwardPrompt">
        点击右上角
        <img src="../../../../assets/threePoints.png" alt />
      </div>
      <div class="forwardPromptTwo">将它转发给指定的朋友</div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import axios from "axios";
import Storage from "@/tools/storage";
import { getPatientInfo, makeOutLink } from "@/api/reportOuter";
import { makeReportLink, getReportInfo } from "@/api/report";
import Vue from "vue";
import { Notify } from "vant";
// import { link } from "fs";
import { config } from "@/config/config"
export default {
  name: "forwardingReport",
  data() {
    return {
      examReport: true,
      montmorillonite: false,
      forwardingData: {},
      reportMeta: {},
      value: 3,
      expirationOpen: false,
      option1: [
        { text: "1天", value: 1 },
        { text: "3天", value: 3 },
        { text: "7天", value: 7 }
      ],
      login: "../../../../../assets/login.png",
      report: true,
      noreport: false,
      message: " \n 本服务由公众号：数字影像云提供",
      result: ["a", "b"],
      isAnonymous: 1,
      isEncrypt: 1,
      linkLoading: false,
      linkReady: false,
      linkError: false,
      generationTimer: null,
      generationVersion: 0,
      initialOptions: null,
      lastGeneratedOptions: null
    };
  },
  computed: {
    maskedName() {
      return this.maskText(this.reportMeta.name);
    },
    maskedHospital() {
      return this.maskText(
        this.reportMeta.local_institution_name ||
        this.reportMeta.remote_institution_name ||
        this.reportMeta.institution_name
      );
    }
  },
  methods: {
    /* 判断是否可以转发 */
    initial() {
      getPatientInfo({
        exam_id: JSON.parse(Storage.get("reportInfo"))[0].exam_id
      }).then(res => {
        if (res.length) {
          if (res[0].exam_status == 9 || res[0].report_status == 9) {
            this.report = true;
            this.noreport = false;
          }
        } else {
          this.report = false;
          this.noreport = true;
        }
      });
    },
    onBack() {
      // this.$router.push({ path: '/filmQuery' })
      this.$router.go(-1);
    },
    toReport() {
      this.$router.push({ path: "/reportInfoOuter/report" });
    },
    toPortrait() {
      this.$router.push({ path: "/reportInfoOuter/portrait" });
    },
    Montmorillonite() {
      this.montmorillonite = false;
    },
    selectExpiration(value) {
      this.value = value;
      this.expirationOpen = false;
      clearTimeout(this.generationTimer);
      this.generationVersion += 1;
      this.linkLoading = true;
      this.linkReady = false;
      this.linkError = false;
      this.getMakeReportLink(this.generationVersion);
    },
    toggleOption(type, enabled) {
      const value = enabled ? 1 : 0;
      if (type === "anonymous") {
        this.isAnonymous = value;
      } else {
        this.isEncrypt = value;
      }
      this.result = [
        ...(this.isEncrypt ? ["a"] : []),
        ...(this.isAnonymous ? ["b"] : [])
      ];
      this.scheduleMakeReportLink();
    },
    getLinkOptions() {
      return {
        anonymous: this.isAnonymous,
        encrypt: this.isEncrypt,
        overdueTime: this.value
      };
    },
    isSameLinkOptions(left, right) {
      return !!left && !!right &&
        left.anonymous === right.anonymous &&
        left.encrypt === right.encrypt &&
        left.overdueTime === right.overdueTime;
    },
    scheduleMakeReportLink() {
      clearTimeout(this.generationTimer);

      const options = this.getLinkOptions();
      this.generationVersion += 1;

      if (this.isSameLinkOptions(options, this.lastGeneratedOptions)) {
        this.linkLoading = false;
        this.linkReady = Boolean(this.forwardingData && this.forwardingData.url);
        this.linkError = false;
        return;
      }

      const version = this.generationVersion;
      this.linkLoading = true;
      this.linkReady = false;
      this.linkError = false;
      this.generationTimer = setTimeout(() => {
        this.getMakeReportLink(version);
      }, 500);
    },
    retryMakeReportLink() {
      clearTimeout(this.generationTimer);
      this.generationVersion += 1;
      this.linkLoading = true;
      this.linkReady = false;
      this.linkError = false;
      this.getMakeReportLink(this.generationVersion);
    },
    maskText(value) {
      const text = value == null ? "" : String(value);
      if (!text) return "****";
      if (text.length === 1) return "*";
      if (text.length === 2) return text.charAt(0) + "*";
      return text.charAt(0) + "**" + text.charAt(text.length - 1);
    },
    getShareUrl(url = this.forwardingData.url) {
      if (!url) return "";

      const cleanUrl = url.replace(/([?&])pwd=[^&]*/g, "$1").replace(/[?&]$/, "");
      if (!this.isEncrypt || !this.forwardingData.code) {
        return cleanUrl;
      }

      const separator = cleanUrl.indexOf("?") === -1 ? "?" : "&";
      return cleanUrl + separator + "pwd=" + encodeURIComponent(this.forwardingData.code);
    },
    async copyShareUrl(text) {
      const oInput = document.createElement("input");
      oInput.type = "text";
      oInput.value = text;
      oInput.setAttribute("readonly", "readonly");
      oInput.style.position = "fixed";
      oInput.style.top = "-1000px";
      oInput.style.left = "-1000px";
      oInput.style.opacity = "0";
      this.$refs.body.appendChild(oInput);

      let copied = false;
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          try {
            await navigator.clipboard.writeText(text);
            copied = true;
          } catch (error) {
            copied = false;
          }
        }

        if (!copied) {
          oInput.focus();
          oInput.select();
          oInput.setSelectionRange(0, oInput.value.length);
          copied = document.execCommand("copy");
        }
      } catch (error) {
        copied = false;
      } finally {
        if (oInput.parentNode) {
          oInput.parentNode.removeChild(oInput);
        }
      }

      return copied;
    },
    async toCopy() {
      if (!this.linkReady || this.linkLoading || !this.forwardingData.url) {
        Notify({ type: "warning", message: "链接生成中，请稍后再试" });
        return;
      }
      if (this.isEncrypt && !this.forwardingData.code) {
        Notify({ type: "warning", message: "访问密码生成中，请稍后再试" });
        return;
      }
      const judge = await this.copyShareUrl(this.getShareUrl());
      if (judge == true) {
        Notify({ type: "success", message: "安全链接复制成功" });
      } else {
        Notify({ type: "danger", message: "复制失败，请手动复制链接" });
      }
    },
    getUrl(url) {
      return this.getShareUrl(url);
    },
    initWxShare() {
      if (!this.forwardingData || !this.forwardingData.url) {
        console.error("转发数据未加载完成");
        return;
      }

      let url = window.location.href
      const firstPart = url.substring(0, url.indexOf('.'));
      const that = this;

      let shareLink = this.getShareUrl();

      // 包装 redirect.html
      shareLink =
        window.location.href.split("#")[0] +
        "redirect.html?shareRedirect=" +
        encodeURIComponent(shareLink);

      let imgUrl = firstPart+".pacsonline.cn/share.png";

      console.log("准备初始化微信分享", {
        shareLink: shareLink,
        title: JSON.parse(Storage.get("reportInfo"))[0].name + "的检查报告",
        desc: "密码:" + that.forwardingData.code + that.message
      });

      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          const appId = res.data.appId;
          const timestamp = res.data.timestamp;
          const nonceStr = res.data.nonceStr;
          const signature = res.data.signature;
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: [
              "updateAppMessageShareData",
              "onMenuShareAppMessage"  // 添加旧接口作为备用
            ]
          });
          wx.ready(function() {
            console.log("微信SDK ready");

            // 优先使用新接口
            wx.updateAppMessageShareData({
              title:
                JSON.parse(Storage.get("reportInfo"))[0].name + "的检查报告",
              desc: "密码:" + that.forwardingData.code + that.message,
              link: shareLink,
              imgUrl: imgUrl,
              success: function(res) {
                that.montmorillonite = false;
                console.log("新接口分享配置成功", res);
              },
              fail: function(err) {
                console.error("新接口分享配置失败，尝试使用旧接口", err);

                // 新接口失败时使用旧接口
                wx.onMenuShareAppMessage({
                  title:
                    JSON.parse(Storage.get("reportInfo"))[0].name + "的检查报告",
                  desc: "密码:" + that.forwardingData.code + that.message,
                  link: shareLink,
                  imgUrl: imgUrl,
                  success: function(res) {
                    that.montmorillonite = false;
                    console.log("旧接口分享配置成功", res);
                  },
                  cancel: function() {
                    that.montmorillonite = false;
                    console.log("取消分享");
                  }
                });
              }
            });
          });
          wx.error(function(res) {
            console.error("微信配置失败", res);
          });
        })
        .catch(err => {
          console.error("获取微信配置失败", err);
        });
    },
    wxSDK() {
      this.montmorillonite = true;
      this.toCopy();
    },
    async getMakeReportLink(version) {
      const requestVersion = version === undefined ? ++this.generationVersion : version;
      const options = this.getLinkOptions();
      this.linkLoading = true;
      this.linkReady = false;
      this.linkError = false;
      const reportInfo = JSON.parse(Storage.get("reportInfo") || "[]");
      const reportItem = reportInfo[0] || {};
      const params = {
        url: config.ipurl + "/#/reportInfoOuter",
        overdueTime: options.overdueTime,
        examId: reportItem.exam_id,
        phone: "",
        report: Storage.get("code") == 2 ? 2 : 1,
        study_id: reportItem.study_id,
        anonymous: options.anonymous,
        encrypt: options.encrypt
      };

      try {
        const res = await makeOutLink(params);
        const isCurrentRequest = requestVersion === this.generationVersion;
        const isCurrentOptions = this.isSameLinkOptions(options, this.getLinkOptions());

        if (!isCurrentRequest || !isCurrentOptions) {
          return false;
        }

        const hasCode = res && res.code !== undefined && res.code !== null && res.code !== "";
        if (!res || !res.url || (options.encrypt === 1 && !hasCode)) {
          this.linkError = true;
          this.linkReady = false;
          return false;
        }
        this.forwardingData = res;
        this.lastGeneratedOptions = options;
        this.linkReady = true;
        this.linkError = false;
        this.initWxShare();
        return true;
      } catch (error) {
        if (requestVersion === this.generationVersion) {
          this.linkError = true;
          this.linkReady = false;
        }
        return false;
      } finally {
        if (requestVersion === this.generationVersion) {
          this.linkLoading = false;
        }
      }
    }
  },
  mounted() {
    this.initial();
    this.initialOptions = {
      anonymous: this.isAnonymous,
      encrypt: this.isEncrypt,
      overdueTime: this.value
    };
    this.getMakeReportLink();
  },
  beforeDestroy() {
    clearTimeout(this.generationTimer);
    this.generationVersion += 1;
  },
  created() {
    const reportInfo = JSON.parse(Storage.get("reportInfo") || "[]");
    if (Array.isArray(reportInfo) && reportInfo.length) {
      this.reportMeta = reportInfo[0];
    }
    if (Storage.get("code") == 2 && Storage.get("examStatus") == 1) {
      this.examReport = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../style/reportInfo/index.css";
.forwardingReport {
  min-height: calc(100vh - 55px);
  background: #f5f6fa;
  color: #1f2533;
  text-align: left;
}
.hierarchy {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 71px 16px 104px;
}
.settingCard {
  margin-bottom: 14px;
  padding: 20px 16px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(39, 58, 86, .06);
}
.expirationCard {
  padding-top: 19px;
  padding-bottom: 18px;
}
.settingHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.settingCopy {
  min-width: 0;
  flex: 1;
}
.settingTitle {
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  color: #141a26;
}
.settingDescription {
  margin-top: 4px;
  color: #4d5564;
  font-size: 14px;
  line-height: 22px;
}
.expirationSelect {
  position: relative;
  flex: 0 0 84px;
  width: 84px;
  margin: -8px -4px 0 0;
}
.expirationTrigger {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 36px;
  padding: 0 2px 0 0;
  border: 0;
  background: transparent;
  color: #27acc2;
  font-size: 21px;
  line-height: 28px;
}
.expirationTrigger .van-icon {
  margin-left: 8px;
  font-size: 14px;
  transition: transform .2s ease;
}
.expirationTrigger .van-icon.open {
  transform: rotate(180deg);
}
.expirationOptions {
  position: absolute;
  top: 42px;
  right: 0;
  z-index: 30;
  width: 112px;
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(35, 46, 66, .18);
}
.expirationOption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  padding: 9px 12px;
  border: 0;
  border-bottom: 1px solid #f0f1f4;
  background: #fff;
  color: #3b4350;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}
.expirationOption:last-child {
  border-bottom: 0;
}
.expirationOption.selected {
  background: #f1f6fd;
  color: #27acc2;
}
.expirationOption .van-icon {
  font-size: 16px;
}
.switchBox {
  display: flex;
  flex: 0 0 54px;
  flex-direction: column;
  align-items: center;
}
.switchControl {
  position: relative;
  display: block;
  width: 50px;
  height: 30px;
  cursor: pointer;
}
.switchControl input {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.switchTrack {
  pointer-events: none;
  display: block;
  width: 50px;
  height: 30px;
  border-radius: 15px;
  background: #d9dce4;
  transition: background .2s ease;
}
.switchThumb {
  display: block;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .18);
  transform: translate(2px, 2px);
  transition: transform .2s ease;
}
.switchControl input:checked + .switchTrack {
  background: #27acc2;
}
.switchControl input:checked + .switchTrack .switchThumb {
  transform: translate(22px, 2px);
}
.switchStatus {
  margin-top: 4px;
  color: #4d5564;
  font-size: 13px;
  line-height: 18px;
}
.settingHint {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 42px;
  margin-top: 16px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #f0f1f5;
  color: #5b6270;
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
}
.passwordHint .van-icon {
  flex: 0 0 auto;
  margin-right: 9px;
  color: #9ca3b1;
  font-size: 19px;
}
.settingFootnote {
  margin-top: 10px;
  color: #8b919d;
  font-size: 13px;
  line-height: 20px;
}
.forwardingActionBar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  box-sizing: border-box;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, .96);
}
.linkError {
  margin-bottom: 8px;
  color: #d9534f;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
}
.copyButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 9px;
  background: #27acc2;
  box-shadow: 0 5px 12px rgba(47, 130, 223, .22);
  color: #fff;
  font-size: 16px;
}
.copyButton .van-icon {
  margin-left: 8px;
  font-size: 19px;
}
.copyButton .van-button__text {
  display: inline-flex;
  align-items: center;
  color: #fff;
}
.white_title {
  height: 100vh;
  line-height: 100vh;
  font-size: 20px;
  text-align: center;
}
.montmorillonite {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .7);
}
.montmorillonite .arrowDirection {
  position: absolute;
  top: 20px;
  right: 30px;
}
.montmorillonite .forwardPrompt {
  position: absolute;
  top: 100px;
  right: 120px;
  color: #fff;
  font-size: 16px;
}
.montmorillonite .forwardPrompt img {
  width: 20px;
  height: 20px;
}
.montmorillonite .forwardPromptTwo {
  position: absolute;
  top: 140px;
  right: 100px;
  color: #fff;
  font-size: 16px;
}
</style>
